<template>
  <div class="qiao_qi_warp">
    <Header />
    <!-- 左侧导航 -->
    <div class="aada">
      <div class="header">人口信息目录</div>
      <!-- 下边导航渐变    background: linear-gradient(to left,#2A4C8B,#1681CF); -->
      <el-row class="tac">
        <el-col :span="12">
          <!-- unique-opened     只让一个菜单展开    -->
          <el-menu
            default-active="2"
            unique-opened
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose"
            background-color="#143A7E"
            text-color="#fff"
            active-text-color="#ffd04b"
          >
            <el-submenu index="1">
              <template slot="title">
                <span
                  style="display: inline-block;
                    padding: 1vh 1vw;
                    width: 15vw;
                    height: 3vh;
                    line-height: 3vh;
                    background: linear-gradient(to left, #143a7e, #1681cf);"
                  >概览统计</span>
              </template>
            </el-submenu>
            <el-submenu index="2" @close="handleClose">
              <template slot="title">
                <!-- <i class="el-icon-menu"></i> -->
                <span
                  slot="title"
                  style="display: inline-block;
                    padding: 1vh 1vw;
                    width: 15vw;
                    height: 3vh;
                    line-height: 3vh;
                    background: linear-gradient(to left, #143a7e, #1681cf);"
                  >常住人口</span>
              </template>
              <el-menu-item-group class="menu-item">
                <el-menu-item index="2-1" @click="index(2.1)"
                  >分地区、户口登记地的常住人口</el-menu-item>
                <el-menu-item index="2-2" @click="index(2.2)"
                  >分地区的常住人口和外来人口</el-menu-item
                >
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="3">
              <span
                slot="title"
                style="display: inline-block;
                    padding: 1vh 1vw;
                    width: 15vw;
                    height: 3vh;
                    line-height: 3vh;
                    background: linear-gradient(to left, #143a7e, #1681cf);"
                >外来人口</span
              >
              <el-menu-item-group>
                <el-menu-item index="3-1" @click="index(3.1)"
                  >常住外来人口离开户口登记地时间</el-menu-item
                >
                <el-menu-item index="3-2" @click="index(3.2)"
                  >常住外来人口离开户口登记地原因</el-menu-item
                >
                <el-menu-item index="3-3" @click="index(3.3)"
                  >分地区、户口登记地的常住外来人口</el-menu-item
                >
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="4">
              <!-- <i class="el-icon-setting"></i> -->
              <span
                slot="title"
                style="display: inline-block;
                    padding: 1vh 1vw;
                    width: 15vw;
                    height: 3vh;
                    line-height: 3vh;
                    background: linear-gradient(to left, #143a7e, #1681cf);"
                >性别</span
              >
              <el-menu-item-group>
                <el-menu-item index="4-1" @click="index(4.1)"
                  >分地区、性别的常住人口</el-menu-item
                >
                <el-menu-item index="4-2" @click="index(4.2)"
                  >分地区、性别的常住外来人口</el-menu-item
                >
                <el-menu-item index="4-3" @click="index(4.3)"
                  >分性别、年龄的常住人口</el-menu-item
                >
                <el-menu-item index="4-4" @click="index(4.4)"
                  >分性别、年龄的常住外来人口</el-menu-item
                >
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="5">
              <!-- <i class="el-icon-setting"></i> -->
              <span
                slot="title"
                style="display: inline-block;
                    padding: 1vh 1vw;
                    width: 15vw;
                    height: 3vh;
                    line-height: 3vh;
                    background: linear-gradient(to left, #143a7e, #1681cf);"
                >年龄</span
              >
              <el-menu-item-group>
                <el-menu-item index="5-1" @click="index(5.1)"
                  >分地区、年龄的常住人口</el-menu-item
                >
                <el-menu-item index="5-2" @click="index(5.2)"
                  >分地区的常住人口年龄构成</el-menu-item
                >
                <el-menu-item index="5-3" @click="index(5.3)"
                  >分地区的常住外来人口年龄构成</el-menu-item
                >
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="6">
              <!-- <i class="el-icon-setting"></i> -->
              <span
                slot="title"
                style="display: inline-block;
                    padding: 1vh 1vw;
                    width: 15vw;
                    height: 3vh;
                    line-height: 3vh;
                    background: linear-gradient(to left, #143a7e, #1681cf);"
                >民族</span
              >
              <el-menu-item-group>
                <el-menu-item index="6-1" @click="index(6.1)"
                  >分民族地区的常住外来人口</el-menu-item
                >
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="7">
              <!-- <i class="el-icon-setting"></i> -->
              <span
                slot="title"
                style="display: inline-block;
                    padding: 1vh 1vw;
                    width: 15vw;
                    height: 3vh;
                    line-height: 3vh;
                    background: linear-gradient(to left, #143a7e, #1681cf);"
                >户信息</span
              >
              <el-menu-item-group>
                <!-- <el-menu-item index="7-1" @click="index(7.1)"
                  >分地区、户别情况</el-menu-item
                > -->
                <el-menu-item index="7-2" @click="index(7.2)"
                  >分地区的常住家庭户住房情况</el-menu-item
                >
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="8">
              <span
                slot="title"
                style="display: inline-block;
                    padding: 1vh 1vw;
                    width: 15vw;
                    height: 3vh;
                    line-height: 3vh;
                    background: linear-gradient(to left, #143a7e, #1681cf);"
                >居住地和户籍地不一致的人口</span
              >
              <el-menu-item-group>
                <el-menu-item index="8-1" @click="index(8.1)"
                  >人户分离人口离开登记地原因</el-menu-item
                >
                <el-menu-item index="8-2" @click="index(8.2)"
                  >人户分离人口离开户口登记地时间</el-menu-item
                >
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="9">
              <span
                slot="title"
                style="display: inline-block;
                    padding: 1vh 1vw;
                    width: 15vw;
                    height: 3vh;
                    line-height: 3vh;
                    background: linear-gradient(to left, #143a7e, #1681cf);"
                    >受教育程度</span>
              <el-menu-item-group>
                <el-menu-item
                  index="9-1"
                  @click="index(9.1)"
                  style="font-size: 12px"
                  >分地区、受教育程度的3岁及以上常住人口</el-menu-item>
                <el-menu-item
                  index="9-2"
                  @click="index(9.2)"
                  style="font-size: 12px"
                  >分地区、受教育程度的3岁及以上常住外来人口</el-menu-item
                >
                <el-menu-item
                  index="9-3"
                  @click="index(9.3)"
                  style="font-size: 12px"
                  >分地区、受教育程度的15岁及以上常住人口</el-menu-item
                >
                <el-menu-item
                  index="9-4"
                  @click="index(9.4)"
                  style="font-size: 12px"
                  >分地区、受教育程度的15岁及以上常住外来人口</el-menu-item
                >
                <el-menu-item
                  index="9-5"
                  @click="index(9.5)"
                  style="font-size: 12px"
                  >分地区、受教育程度的16-59岁及以上常住人口</el-menu-item
                >
                <el-menu-item
                  index="9-6"
                  @click="index(9.6)"
                  style="font-size: 12px"
                  >分地区、受教育程度的16-59岁及以上常住外来人口</el-menu-item
                >
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="10">
              <!-- <i class="el-icon-setting"></i> -->
              <span
                slot="title"
                style="display: inline-block;
                    padding: 1vh 1vw;
                    width: 15vw;
                    height: 3vh;
                    line-height: 3vh;
                    background: linear-gradient(to left, #143a7e, #1681cf);"
                >港澳台和外籍人员</span
              >
              <el-menu-item-group>
                <el-menu-item index="10-1" @click="index(10.1)"
                  >分地区的港澳台和外籍人员</el-menu-item
                >
                <!-- <el-menu-item index="10-2" @click="index(10.2)"
                  >分地区的港澳台和外籍人员居住原因</el-menu-item
                > -->
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </el-col>
      </el-row>
    </div>
    <!-- 右侧显示页面 -->
    <div class="aadc">
      <div class="headers" v-if="key == 1">
        <div>概览统计</div>
        <div class="twoss">
          <div class="one">
            <span>{{ list.zhs }}</span
            ><span>(户)</span>
            <div>总户数</div>
          </div>
          <div class="two one">
            <span>{{ list.czrk }}</span
            ><span>(人)</span>
            <div>常住人口</div>
          </div>
          <div class="cc one">
            <span>{{ list.swsjysrk }}</span
            ><span>(人)</span>
            <div>15岁及以上人口</div>
          </div>
          <div class="cc one">
            <span>{{ list.gatjwgrk }}</span
            ><span>(人)</span>
            <div>港澳台及外国人口</div>
          </div>
        </div>
        <div class="text">
          <div>{{ list.villagesName }}</div>
          <p>
            {{ list.qyxx }}
          </p>
        </div>
        <!-- <img src="../../assets/img/bar.png" alt=""> -->
      </div>
      <!-- 常住人口 -->
      <Rkcz v-if="key == 2 && indexs != 2.2" />
      <Rkwl v-if="indexs == 2.2 && key == 2" />
      <!-- 外来人口 -->
      <Czsj v-if="key == 3 && indexs != 3.2 && indexs != 3.3" />
      <Czyy v-if="indexs == 3.2 && key == 3" />
      <Dqcz v-if="indexs == 3.3 && key == 3" />
      <!-- 性别 -->
      <Dqcza v-if="key == 4 && indexs != 4.2 && indexs != 4.3 && indexs != 4.4"/>
      <Dqwl v-if="indexs == 4.2 && key == 4" />
      <Xbcz v-if="indexs == 4.3 && key == 4" />
      <Xbwl v-if="indexs == 4.4 && key == 4" />
      <!-- 年龄 -->
      <Dqczb v-if="key == 5 && indexs != 5.2 && indexs != 5.3" />
      <Dqnl v-if="indexs == 5.2 && key == 5" />
      <Dqwla v-if="indexs == 5.3 && key == 5" />
      <!-- 民族 -->
      <Mzwl v-if="key == 6 && indexs != 6.2" />
      <!-- 户信息 -->
      <!-- <Dqhb v-if="key == 7 && indexs != 7.2" /> -->
      <Dqczc v-if="indexs !== 7.2 && key == 7" />
      <!-- 居住地和户籍地不一致 -->
      <Flyy v-if="key == 8 && indexs != 8.2" />
      <Flsj v-if="indexs == 8.2 && key == 8" />
      <!-- 受教育程度 -->
      <Dqssscz
        v-if="
          key == 9 &&
          indexs != 9.2 &&
          indexs != 9.3 &&
          indexs != 9.4 &&
          indexs != 9.5 &&
          indexs != 9.6
        "
      />
      <Dqssswl v-if="indexs == 9.2 && key == 9" />
      <Dqlsscz v-if="indexs == 9.3 && key == 9" />
      <Dqlsswl v-if="indexs == 9.4 && key == 9" />
      <Dqlsswls v-if="indexs == 9.5 && key == 9" />
      <Dqlsswlss v-if="indexs == 9.6 && key == 9" />
      <!-- 港澳台和外来人员 -->
      <Gat v-if="key == 10 && indexs != 10.2" />
      <!-- <Gatyy v-if="indexs == 10.2 && key == 10" /> -->
      <img class="img" src="../../assets/img/bar.png" alt="" />
    </div>
    <!-- 点击切换 -->
    <img
      class="imagemin"
      @click="dianjis"
      src="../../assets/img/jxq2.jpg"
      alt=""
    />
    <!-- v-if="shows" -->
    <div class="mapWarp">
      <!-- <div id="container" ref="container"></div> -->
      <img class="image" src="../../assets/img/jxq1.jpg" alt="">
    </div>
    <img v-if="showss" class="image" src="../../assets/img/jxq2.jpg" alt="" />
  </div>
</template>

<script>
//头部导航
import Header from "../../components/header.vue";
//常住人口
import Rkcz from "../rfq/cnps/czrk/rkcz.vue";
import Rkwl from "../rfq/cnps/czrk/rkwl.vue";
// 外来人口
import Czsj from "../rfq/cnps/wlrk/czsj.vue";
import Czyy from "../rfq/cnps/wlrk/czyy.vue";
import Dqcz from "../rfq/cnps/wlrk/dqcz.vue";
// 性别
import Dqcza from "../rfq/cnps/sex/dqcz.vue";
import Dqwl from "../rfq/cnps/sex/dqwl.vue";
import Xbcz from "../rfq/cnps/sex/xbcz.vue";
import Xbwl from "../rfq/cnps/sex/xbwl.vue";
// 年龄
import Dqczb from "../rfq/cnps/age/dqcz.vue";
import Dqnl from "../rfq/cnps/age/dqnl.vue";
import Dqwla from "../rfq/cnps/age/dqwl.vue";
// 民族
import Mzwl from "../rfq/cnps/mz/mzwl.vue";
// 户信息
import Dqhb from "../rfq/cnps/hxx/dqhb.vue";
import Dqczc from "../rfq/cnps/hxx/dqcz.vue";
// 居住地和户籍地不一致
import Flyy from "../rfq/cnps/jzd/flyy.vue";
import Flsj from "../rfq/cnps/jzd/flsj.vue";
// 受教育程度
import Dqssscz from "../rfq/cnps/sjycd/dqssscz.vue";
import Dqssswl from "../rfq/cnps/sjycd/dqssswl.vue";
import Dqlsscz from "../rfq/cnps/sjycd/dqlsscz.vue";
import Dqlsswl from "../rfq/cnps/sjycd/dqlsswl.vue";
import Dqlsswls from "../rfq/cnps/sjycd/dqlsswls.vue";
import Dqlsswlss from "../rfq/cnps/sjycd/dqlsswlss.vue";
// 港澳台和外来人员
import Gat from "../rfq/cnps/gat/gat.vue";
import Gatyy from "../rfq/cnps/gat/gatyy.vue";

import { list } from "@/network";
export default {
  components: {
    Header,
    Rkcz,
    Rkwl,
    Czsj,
    Czyy,
    Dqcz,
    Dqcza,
    Dqwl,
    Xbcz,
    Xbwl,
    Dqczb,
    Dqnl,
    Dqwla,
    Mzwl,
    Dqhb,
    Dqczc,
    Flyy,
    Flsj,
    Dqssscz,
    Dqssswl,
    Dqlsscz,
    Dqlsswl,
    Dqlsswls,
    Dqlsswlss,
    Gat,
    Gatyy,
  },
  data() {
    return {
      // shows:true,
      showss: false,
      map: null,
      key: "1",
      indexs: "",
      list: {},
    };
  },
  created() {},
  mounted() {
    this.getinfoListss();
    // this.mapList();
  },
  methods: {
    // 人口概览  list
    async getinfoListss() {
      console.log(111)
      const { code, data, msg } = await list(1);
      this.list = data;
    },
    //左侧导航
    handleOpen(key, keyPath) {
      this.key = key;
      // console.log(this.key, keyPath, "header");
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath, "body");
    },
    index(e) {
      this.indexs = e;
      // console.log(this.indexs, "body1");
    },

    mapList() {
      this.map = new BMap.Map(this.$refs.container); // 创建Map实例
      this.map.centerAndZoom(new BMap.Point(116.502, 39.979), 15); // 初始
      this.map.enableScrollWheelZoom(true);
      this.getBoundary();
    },
    getBoundary() {
      // this.map.clearOverlays(); // 清除地图的其余覆盖物
      const bdary = new BMap.Boundary();
      bdary.get("北京市朝阳区", (rs) => {
        const count = rs.boundaries.length;
        if (count === 0) {
          return;
        }
        const EN_JW = "180, 90;";
        const NW_JW = "-180,  90;";
        const WS_JW = "-180, -90;";
        const SE_JW = "180, -90;";
        // 东南西北四个角添加一个覆盖物
        const ply1 = new BMap.Polygon(
          rs.boundaries[0] + SE_JW + SE_JW + WS_JW + NW_JW + EN_JW + SE_JW,
          {
            strokeColor: "none",
            fillColor: "#333",
            fillOpacity: 1,
            strokeOpacity: 1,
          }
        );
        // 添加覆盖物
        //  var ply1 = new BMap.Polygon(rs.boundaries[0] + SE_JW + SE_JW + WS_JW + NW_JW + EN_JW + SE_JW, { strokeColor: "none", fillColor: "rgb(246,246,246)", fillOpacity:1, strokeOpacity: 0.5 }); //建立多边形覆盖物
        // this.map.addOverlay(ply1);
        //5. 给目标行政区划添加边框，其实就是给目标行政区划添加一个没有填充物的遮罩层
        var ply = new BMap.Polygon(rs.boundaries[0], {
          strokeWeight: 2,
          strokeColor: "#00f",
          fillColor: "#465B74",
        });

        this.map.addOverlay(ply);
        this.map.setViewport(ply.getPath()); //调整视野
      });
    },
    dianjis() {
      // this.shows=!this.shows
      this.showss = !this.showss;
      this.mapList();
      if (this.shows == true) {
        // location.reload();
      }
    },
  },
};
</script>

<style scoped lang="less">
.imagemin {
  width: 100px;
  width: 100px;
  position: fixed;
  bottom: 5%;
  left: 60%;
  z-index: 99;
  border: 2px solid #000;
}
.image {
  width: 100vw;
  height: 92vh;
  position: fixed;
  top: 8%;
  left: 0%;
}
.qiao_qi_warp {
  height: 97%;
  .aada {
    width: 19vw;
    height: 88vh;
    background-color: rgba(20, 58, 126, 0.9);
    z-index: 100;
    position: absolute;
    top: 9vh;
    left: 0.5vw;
    .header {
      background: linear-gradient(to left, #143a7e, #132d43);
      // background:-webkit-gradient(linear, 0 0, 0 bottom, from(#ff0000), to(rgba(0, 0, 255, 0.5)));
      height: 5vh;
      line-height: 5vh;
      text-align: center;
      color: #fff;
    }
    
    .el-menu-vertical-demo {
      width: 19vw;
      height: 85vh;
      overflow-y: auto;
      overflow-x: auto;
      // .menu-item{
      //   div{
      //     padding-top:0px !important;
      //   }
      // }
    }
    
    //改变滚动条样式
    .el-menu-vertical-demo::-webkit-scrollbar {
      //滚动条整体样式
      width: 4px;
      height: 4px;
    }
    .el-menu-vertical-demo::-webkit-scrollbar-thumb {
      //滚动条内部小方块样式
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      background: rgba(255, 255, 255, 0.2);
    }
    .el-menu-vertical-demo::-webkit-scrollbar-track {
      //滚动条内部轨道
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      border-radius: 0;
      background: rgba(255, 255, 255, 0.1);
    }
  }
  .aadc {
    width: 32vw;
    height: 90vh;
    background-color: rgba(20, 48, 99, 0.9);
    z-index: 100;
    position: absolute;
    top: 9vh;
    right: 0.5vw;
    .img {
      position: fixed;
      width: 32vw;
      bottom: 2vh;
    }
    .headers {
      color: #fff;
      text-align: center;
      margin-top: 2vh;
      font-size: 18px;
      .twoss {
        border: 1px solid #21517d;
        margin: 4vh 2vw;
        .one {
          width: 12vw;
          margin-top: 2vh;
          display: inline-block;
          font-size: 18px;
          color: #fffd7d;
          padding-top: 1vh;
          span:nth-child(2) {
            font-size: 12px;
          }
          div {
            font-size: 12px;
            color: #fff;
            margin-top: 5px;
          }
        }
        .cc {
          margin-bottom: 4vh;
        }
        // .two {
        //   display: inline-block;
        //   font-size: 18px;
        //   border: 1px solid #21517d;
        //   padding: 3vh 4vw;
        //   color: #fffd7d;
        //   border-bottom: 0;
        //   span:nth-child(2) {
        //     font-size: 12px;
        //   }
        //   div {
        //     font-size: 12px;
        //     color: #fff;
        //     margin-top: 4px;
        //   }
        // }
        // .cc {
        //   display: inline-block;
        //   font-size: 18px;
        //   border: 1px solid #21517d;
        //   padding: 3vh 3.6vw;
        //   color: #fffd7d;
        //   border-right: 0;
        //   span:nth-child(2) {
        //     font-size: 12px;
        //   }
        //   div {
        //     font-size: 12px;
        //     color: #fff;
        //     margin-top: 4px;
        //   }
        // }
        // .dd {
        //   display: inline-block;
        //   font-size: 18px;
        //   border: 1px solid #21517d;
        //   padding: 3vh 3.3vw;
        //   color: #fffd7d;
        //   span:nth-child(2) {
        //     font-size: 12px;
        //   }
        //   div {
        //     font-size: 12px;
        //     color: #fff;
        //     margin-top: 4px;
        //   }
        // }
      }
      .text {
        border: 1px solid #21517d;
        margin: 2vw;
        padding: 1vw;
        div {
          background-color: #21517d;
          height: 4vh;
          line-height: 4vh;
          text-align: left;
          padding-left: 1vw;
          margin-bottom: 1vw;
        }
        p {
          text-indent: 2em;
          text-align: left;
          line-height: 3.8vh;
          font-size: 16px;
        }
      }
      img {
        width: 100%;
        margin-top: 3.9vh;
      }
    }
  }
  .mapWarp {
    width: 100%;
    height: 94%;
    overflow: hidden;
    #container {
      width: 100%;
      height: 100%;
    }
    .image{
      width: 100vw;
      height: 92vh;
      position: fixed;
      top: 8%;
      left: 0%;
    }
  }
}
</style>
